import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
class RouteBuilder {
    prePend(pieces) {
        let path = '';
        Array.from(pieces).forEach(x => {
            path += `${x}/`;
        });
        return path;
    }
}
class BaseRoute extends RouteBuilder {
    constructor(Name, Path) {
        super();
        this.Name = Name;
        this.Path = Path;
        if (Path === undefined) {
            this.Path = `/${Name}`;
        }
    }
    /// <summary>
    /// for this function to work properly provide path consts from first level to last level parent
    /// if you mess that up don't complain go fuckyourself.
    /// </summary>
    buildOwnPath(parents) {
        this.Path = `/${this.prePend(parents)}${this.Name}`;
        // console.log(this.path);
        return this;
    }
}
export class DashboardRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.DashRoute = new BaseRoute('dashboard');
        this.Item = new BaseRoute(`item`);
    }
}
export class AuthenticationRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.Login = new BaseRoute('login');
    }
}
export class CustomerRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.List = new BaseRoute('customer');
    }
}
export class SupplierRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.List = new BaseRoute('supplier');
    }
}
export class PurchaseRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.PurchaseRequisition = new BaseRoute('purchase-requsition');
        this.PurchaseOrder = new BaseRoute('purchase-order');
        this.Purchase = new BaseRoute('purchase');
        this.purchasepdf = new BaseRoute('purchase-pdf-invoice');
    }
}
export class InventoryRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.Stocks = new BaseRoute('stock-list');
        this.InventoryFlow = new BaseRoute('inventory-flow-report');
    }
}
export class SaleRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.Sale = new BaseRoute('sale');
        this.repair = new BaseRoute('repair-order');
        this.prepareinvoice = new BaseRoute('prepare-invoice');
        this.repairorderlist = new BaseRoute('repair-order-list');
        this.allsaleslist = new BaseRoute('all-sales-list');
        this.wiprepairorders = new BaseRoute('wip-repair-orders');
        this.readylist = new BaseRoute('ready-list');
        this.directSale = new BaseRoute('direct-sale');
        this.directsalelist = new BaseRoute('direct-sale-list');
        this.paymentstatus = new BaseRoute('payment-status');
        this.bulkPayment = new BaseRoute('bulk-payments');
        this.bulkPaymentList = new BaseRoute('bulk-payments-list');
        this.salecompleted = new BaseRoute('sale-completed');
        this.quotation = new BaseRoute('quotation');
    }
}
export class VehicleRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.List = new BaseRoute('vehicle');
        this.VehicleNotify = new BaseRoute('vehicle-notify');
    }
}
export class GarageSettingRoutes extends RouteBuilder {
    constructor() {
        super(...arguments);
        this.GarageRoute = new BaseRoute('garage-settings');
        this.FuleType = new BaseRoute(`fule-type`).buildOwnPath([this.GarageRoute.Name]);
        this.Brand = new BaseRoute(`brand`).buildOwnPath([this.GarageRoute.Name]);
        this.Item = new BaseRoute(`item`).buildOwnPath([this.GarageRoute.Name]);
        this.ItemStockReport = new BaseRoute(`stock-report`).buildOwnPath([this.GarageRoute.Name]);
        this.WareHouseItemStockReport = new BaseRoute(`warehouse-stock-report`).buildOwnPath([this.GarageRoute.Name]);
        this.AggingReport = new BaseRoute(`agging-report`).buildOwnPath([this.GarageRoute.Name]);
        this.SalesReport = new BaseRoute(`sales-report`).buildOwnPath([this.GarageRoute.Name]);
        this.StockAdjustment = new BaseRoute(`stock-adjustment-list`).buildOwnPath([this.GarageRoute.Name]);
        this.ItemType = new BaseRoute(`item-type`).buildOwnPath([this.GarageRoute.Name]);
        this.Manufacturer = new BaseRoute(`manufacturer`).buildOwnPath([this.GarageRoute.Name]);
        this.VehicleModel = new BaseRoute(`model`).buildOwnPath([this.GarageRoute.Name]);
        this.SsCategory = new BaseRoute(`ss-category`).buildOwnPath([this.GarageRoute.Name]);
        this.StatusType = new BaseRoute(`status-type`).buildOwnPath([this.GarageRoute.Name]);
        this.Tags = new BaseRoute(`tags`).buildOwnPath([this.GarageRoute.Name]);
        this.TagsType = new BaseRoute(`tags-type`).buildOwnPath([this.GarageRoute.Name]);
        this.PackageType = new BaseRoute(`package-type`).buildOwnPath([this.GarageRoute.Name]);
        this.Package = new BaseRoute(`package`).buildOwnPath([this.GarageRoute.Name]);
        this.Colors = new BaseRoute(`colors`).buildOwnPath([this.GarageRoute.Name]);
        this.ComplainsAndSuggestions = new BaseRoute(`complains-and-suggestions`).buildOwnPath([this.GarageRoute.Name]);
        this.Units = new BaseRoute(`units`).buildOwnPath([this.GarageRoute.Name]);
        this.Countries = new BaseRoute(`countries`).buildOwnPath([this.GarageRoute.Name]);
        this.Warehouse = new BaseRoute(`warehouse`).buildOwnPath([this.GarageRoute.Name]);
        this.VMHReport = new BaseRoute(`vmh-report`).buildOwnPath([this.GarageRoute.Name]);
        this.VehicleStatus = new BaseRoute(`vehicle-status`).buildOwnPath([this.GarageRoute.Name]);
    }
}
// main exporter
let RouteConsts = class RouteConsts {
    // main exporter
    constructor() {
        this.DashBoard = new DashboardRoutes();
        this.Authentication = new AuthenticationRoutes();
        this.GarageSettings = new GarageSettingRoutes();
        this.Customer = new CustomerRoutes();
        this.Supplier = new SupplierRoutes();
        this.Vehicle = new VehicleRoutes();
        this.Purchase = new PurchaseRoutes();
        this.Sale = new SaleRoutes();
        this.repair = new SaleRoutes();
        this.inventory = new InventoryRoutes();
    }
};
RouteConsts = tslib_1.__decorate([
    Injectable()
], RouteConsts);
export { RouteConsts };
//# sourceMappingURL=route-consts.js.map